import CargoGrid from './grid.cargo'

export default CargoGrid